import type { MenuItem, MenuSeparator } from '@graftcode/design-system'

export function groupItemsIntoSections(items: (MenuItem | MenuSeparator)[]): MenuItem[][] {
  const sections: MenuItem[][] = []
  let current: MenuItem[] = []

  for (const item of items) {
    if (item.type === 'separator') {
      if (current.length > 0) {
        sections.push(current)
        current = []
      }
      continue
    }
    current.push(item)
  }

  if (current.length > 0) {
    sections.push(current)
  }

  return sections
}
